module.exports = __webpack_public_path__ + "static/media/Consumables.c57fbb62.png";